// Contrail V3.6.0 (V3.9.0: link back to trackingfiji.com; V3.11.0: platform notice box) — sign-in page, option C "Split console" (Login Background dev brief R1.1).
// Only the layout changed: sign-in logic, errors and "Forgot password?" → /reset (V3.5.1 code flow) are as before.
import { FormEvent, useState } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "../lib/supabase";
import LoginBackground from "./login/LoginBackground";
import { StatusLoginBox } from "../ui/StatusNotice";

export default function Login() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function submit(e: FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    const { error } = await supabase.auth.signInWithPassword({ email: email.trim(), password });
    if (error) setError(error.message === "Invalid login credentials" ? "Email or password is incorrect." : error.message);
    setBusy(false);
  }

  // "Forgot password?" goes to /reset, which works with an emailed code (no one-time link)
  return (
    <div className="lp">
      <LoginBackground />
      <main className="lp-main">
        <a className="lp-home" href="https://trackingfiji.com" title="Back to the Tracking Fiji website">
          <svg viewBox="0 0 16 16" width="14" height="14" aria-hidden="true"><path d="M10 3 5 8l5 5" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" /></svg>
          trackingfiji.com
        </a>
        <form className="lp-form" onSubmit={submit}>
          <img src="/tf-logo.png" alt="Tracking Fiji" className="lp-logo" />
          <StatusLoginBox />
          <div className="lp-head">
            <h1>Sign in</h1>
            <p>Live tracking for your fleet and vessels.</p>
          </div>
          <div className="lp-field">
            <label htmlFor="lp-email">Email</label>
            <input id="lp-email" className="lp-in" type="email" autoComplete="username" value={email} onChange={(e) => setEmail(e.target.value)} required />
          </div>
          <div className="lp-field">
            <label htmlFor="lp-pw">Password</label>
            <input id="lp-pw" className="lp-in" type="password" autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} required />
          </div>
          {error && <div className="error" role="alert">{error}</div>}
          <button className="lp-btn" disabled={busy}>{busy ? "Signing in…" : "Sign in"}</button>
          <button type="button" className="lp-forgot" onClick={() => nav(`/reset${email.trim() ? `?email=${encodeURIComponent(email.trim())}&step=email` : ""}`)}>Forgot password?</button>
          <p className="lp-fine">Tracking Fiji is operated by Skyward Industries Pte Ltd</p>
        </form>
      </main>
    </div>
  );
}
